/**
 * announcement-delivery-countdown-pe.js  (v3 — prefijo de zona + textos ampliados)
 * Integra coverage-pe.js con el primer slide del announcement bar de Perú.
 * Requiere coverage-pe.js (y coverage-pe-data.js) cargados antes.
 *
 * Compone: [En NOMBRE] [recojo]  ·  [envío]
 *   - Prefijo de zona "En {nombre}" al inicio (Tier 1 = "En Lima moderna";
 *     Tiers 2-6 = distrito/provincia/departamento; Tier 7 = SIN nombre).
 *   - Recojo y envío como dos dimensiones con sus countdowns.
 *   - Tier 6: envío fijo "hasta 7 días hábiles" (sin nombrar día).
 *   - Tier 7: solo recojo, sin countdown, texto fijo nacional.
 *   - Sin ubicación -> NO toca el slide (queda el del editor).
 */
(function () {
  'use strict';

  var CFG = window.ANNOUNCEMENT_CONFIG_PE || {};
  function txt(v, def) { return (typeof v === 'string' && v.length) ? v : def; }

  var TXT = {
    // Prefijo de zona
    enZona:           txt(CFG.txtEnZona,           'En {zona} '),
    // Recojo
    recojoAbierto:    txt(CFG.txtRecojoAbierto,    'recoge en tienda en <strong>1 hora</strong>'),
    recojoCountdown:  txt(CFG.txtRecojoCountdown,  'quedan {cd} para recoger en tienda <strong>HOY</strong>'),
    recojoUrgente:    txt(CFG.txtRecojoUrgente,    'últimos {cd} para recoger en tienda <strong>HOY</strong>'),
    recojoCerrado:    txt(CFG.txtRecojoCerrado,    'recoge en tienda desde las <strong>10:00 a.m.</strong>'),
    // Recojo Tier 7 (nacional, fijo, sin countdown ni nombre)
    recojoNacional:   txt(CFG.txtRecojoNacional,   'Recojo en tienda en <strong>1 hora</strong> a nivel nacional'),
    recojoNacionalCerrado: txt(CFG.txtRecojoNacionalCerrado, 'Recojo en tienda a nivel nacional desde las <strong>10:00 a.m.</strong>'),
    // Envío
    envioBeneficio:   txt(CFG.txtEnvioBeneficio,   'recíbelo a domicilio <strong>HOY</strong> si compras antes de las <strong>{hora}</strong>'),
    envioCountdown:   txt(CFG.txtEnvioCountdown,   'quedan {cd} para recibir a domicilio <strong>HOY</strong>'),
    envioUrgente:     txt(CFG.txtEnvioUrgente,     'últimos {cd} para recibir a domicilio <strong>HOY</strong>'),
    envioDia:         txt(CFG.txtEnvioDia,         'recíbelo a domicilio {label}'),
    envioFijo7:       txt(CFG.txtEnvioFijo7,       'envío a domicilio en hasta <strong>7 días hábiles</strong>'),
    // Separador
    sep:              txt(CFG.txtSeparador,        '  ·  ')
  };

  var SLIDE_SEL = '#announcement-bar-section .ann-slide[data-index="0"] .message-part';
  var MARK = 'data-delivery-dynamic';
  var SIG  = 'data-delivery-sig';

  function fmtHora(h) {
    var ampm = h >= 12 ? 'p.m.' : 'a.m.';
    var h12 = h % 12; if (h12 === 0) h12 = 12;
    var e = Math.floor(h12), m = Math.round((h12 - e) * 60);
    return e + (m ? ':' + (m < 10 ? '0' : '') + m : ':00') + ' ' + ampm + (h === 12 ? ' (mediodía)' : '');
  }
  // El artículo cambia con la hora: "la 1:00 p.m." pero "las 10:00 a.m.". Con el
  // corte a las 12 el texto del editor traía "las" fijo y colaba; con 13 no. Lo
  // pone el JS, y si el texto del editor todavía trae su propio "la/las" delante
  // de {hora} se lo quitamos, para que un setting viejo no imprima "las la 1:00".
  function horaConArticulo(h) {
    var h12 = Math.floor(h % 12); if (h12 === 0) h12 = 12;
    return (h12 === 1 ? 'la ' : 'las ') + fmtHora(h);
  }
  function sinArticuloDuplicado(tpl) {
    return tpl.replace(/\b(?:la|las)\s+(?=(?:<[^>]*>\s*)*\{hora\})/, '');
  }

  function fmtCd(s) {
    if (s < 0) s = 0;
    var h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), ss = s % 60;
    if (h > 0) return h + 'h ' + (m < 10 ? '0' : '') + m + 'm';
    if (m > 0) return m + 'm ' + (ss < 10 ? '0' : '') + ss + 's';
    return ss + 's';
  }
  function cdSpan(cls, s) { return '<strong class="js-cd ' + cls + '">' + fmtCd(s) + '</strong>'; }

  // Capitaliza la primera LETRA visible de la cadena, saltando cualquier tag HTML
  // inicial (p. ej. "<strong>recíbelo" -> "<strong>Recíbelo").
  function capitalizar(str) {
    if (!str) return str;
    return str.replace(/^(\s*(?:<[^>]+>\s*)*)([a-záéíóúñ])/i, function (m, tags, ch) {
      return tags + ch.toUpperCase();
    });
  }

  // ---- Parte de RECOJO (tiers 1,2,4; el 7 se maneja aparte) ----
  function htmlRecojo(d) {
    if (!d.recojo) return '';
    var r = d.recojo;
    if (r.estado === 'abierto')   return TXT.recojoAbierto;
    if (r.estado === 'cerrado')   return TXT.recojoCerrado;
    if (r.estado === 'countdown') return TXT.recojoCountdown.replace('{cd}', cdSpan('js-cd-recojo', r.segundosRestantes));
    if (r.estado === 'urgente')   return TXT.recojoUrgente.replace('{cd}', cdSpan('js-cd-recojo', r.segundosRestantes));
    return '';
  }

  // ---- Parte de ENVÍO ----
  function htmlEnvio(d) {
    if (!d.envio) return '';
    var e = d.envio;
    if (d.tier === 6) return TXT.envioFijo7;   // Tier 6: texto fijo, sin día
    if (e.estado === 'hoy_beneficio') {
      return sinArticuloDuplicado(TXT.envioBeneficio)
        .replace('{hora}', horaConArticulo(e.corteHora));
    }
    if (e.estado === 'hoy_countdown') return TXT.envioCountdown.replace('{cd}', cdSpan('js-cd-envio', e.segundosRestantes));
    if (e.estado === 'hoy_urgente')   return TXT.envioUrgente.replace('{cd}', cdSpan('js-cd-envio', e.segundosRestantes));
    if (e.estado === 'dia') {
      var dl = e.diaLabel || { dia: 'PRONTO', conEl: false };
      var etiqueta = (dl.conEl ? 'el ' : '') + '<strong>' + dl.dia + '</strong>';
      return TXT.envioDia.replace('{label}', etiqueta);
    }
    return '';
  }

  function construir(d) {
    if (!d || d.estadoGeneral === 'generico' || d.tier === null) return null;

    // Tier 7: solo recojo nacional, fijo, sin countdown ni nombre.
    if (d.tier === 7) {
      if (d.recojo && d.recojo.estado === 'cerrado') return TXT.recojoNacionalCerrado;
      return TXT.recojoNacional;
    }

    var pre = htmlRecojo(d);
    var env = htmlEnvio(d);
    var nombre = d.nombre || '';
    var prefijo = nombre ? TXT.enZona.replace('{zona}', nombre) : '';

    // La primera cláusula sigue al prefijo "En {zona} " en minúscula (o se capitaliza
    // si no hay prefijo). La segunda cláusula (tras el separador) es una oración
    // independiente, así que SIEMPRE se capitaliza.
    var partes = [];
    if (pre) partes.push(pre);
    if (env) partes.push(env);
    if (partes.length === 0) return null;

    var primera = prefijo ? partes[0] : capitalizar(partes[0]);
    var resto = partes.slice(1).map(function (p) { return capitalizar(p); });

    // El editor de temas recorta los espacios de los settings de texto: "  ·  "
    // se guarda como "·" y las dos cláusulas salen pegadas ("1 hora·Recíbelo").
    // Se los devolvemos aquí, igual que con el prefijo de zona más abajo.
    var sepClausulas = /\s/.test(TXT.sep) ? TXT.sep : '  ' + TXT.sep + '  ';
    var cuerpo = [primera].concat(resto).join(sepClausulas);

    // El prefijo "En {zona}" debe ir separado del cuerpo por un espacio. El setting
    // del editor suele recortar el espacio final, así que lo garantizamos aquí:
    // si hay prefijo y no termina ya en espacio, insertamos uno.
    var sep = (prefijo && !/\s$/.test(prefijo)) ? ' ' : '';
    return prefijo + sep + cuerpo;
  }

  function firma(d) {
    if (!d || !d.tier) return 'x';
    var r = d.recojo ? d.recojo.estado : '-';
    var e = d.envio ? d.envio.estado : '-';
    return d.tier + '|' + r + '|' + e;
  }

  var cdTimer = null;

  function refrescarNumeros(slide, d) {
    var rEl = slide.querySelector('.js-cd-recojo');
    if (rEl && d.recojo) rEl.textContent = fmtCd(d.recojo.segundosRestantes);
    var eEl = slide.querySelector('.js-cd-envio');
    if (eEl && d.envio && /hoy_/.test(d.envio.estado)) eEl.textContent = fmtCd(d.envio.segundosRestantes);
  }

  function aplicar(slide) {
    if (!window.iShopCoveragePE) return;
    var d = window.iShopCoveragePE.detalle();
    var built = construir(d);

    if (built === null) {
      if (slide.getAttribute(MARK) === '1' && slide._origHTML != null) {
        slide.innerHTML = slide._origHTML;
        slide.removeAttribute(MARK); slide.removeAttribute(SIG);
      }
      if (cdTimer) { clearInterval(cdTimer); cdTimer = null; }
      return;
    }

    if (slide._origHTML == null) slide._origHTML = slide.innerHTML;
    slide.innerHTML = built;
    slide.setAttribute(MARK, '1');
    slide.setAttribute(SIG, firma(d));

    if (cdTimer) { clearInterval(cdTimer); cdTimer = null; }

    var rActivo = d.recojo && (d.recojo.estado === 'countdown' || d.recojo.estado === 'urgente');
    var eActivo = d.envio && (d.envio.estado === 'hoy_countdown' || d.envio.estado === 'hoy_urgente');
    // En Tier 7 no hay countdown (se ignora aunque recojo tenga estado).
    if (d.tier === 7) { rActivo = false; eActivo = false; }

    if (rActivo || eActivo) {
      cdTimer = setInterval(function () {
        var dd = window.iShopCoveragePE.detalle();
        if (firma(dd) !== slide.getAttribute(SIG)) { aplicar(slide); return; }
        var rA = dd.recojo && (dd.recojo.estado === 'countdown' || dd.recojo.estado === 'urgente');
        var eA = dd.envio && (dd.envio.estado === 'hoy_countdown' || dd.envio.estado === 'hoy_urgente');
        if (dd.tier === 7) { rA = false; eA = false; }
        if (!rA && !eA) { aplicar(slide); return; }
        refrescarNumeros(slide, dd);
      }, 1000);
    }
  }

  function hayUbicacion() {
    try { if (window.localStorage && localStorage.getItem('preferredStoreId')) return true; } catch (e) {}
    return document.cookie.indexOf('location_position=') !== -1;
  }

  // Listener PERMANENTE: cada vez que el GPS se refresca (cookie reescrita),
  // repintamos. Esto cubre el caso de cookie vieja -> lectura fresca en la misma
  // carga (el usuario se movió de zona desde la última visita).
  function engancharLocationReady(slide) {
    document.addEventListener('ishop:location-ready', function () {
      var s = document.querySelector(SLIDE_SEL) || slide;
      if (s) aplicar(s);
    });
  }

  // Si todavía NO hay ninguna pista de ubicación, esperamos por si otro script
  // setea la cookie (p. ej. un store locator) durante los primeros segundos.
  function vigilarUbicacion(slide) {
    if (hayUbicacion()) return;
    var intentos = 0, MAX = 24;
    var iv = setInterval(function () {
      intentos++;
      if (hayUbicacion()) { clearInterval(iv); aplicar(slide); }
      else if (intentos >= MAX) { clearInterval(iv); }
    }, 500);
  }
  function init() {
    var slide = document.querySelector(SLIDE_SEL);
    if (!slide) return false;
    engancharLocationReady(slide);
    aplicar(slide);          // pinta con lo que haya ahora (cookie vieja/tienda)
    vigilarUbicacion(slide); // espera si aún no hay nada
    // Refresco silencioso: si el permiso ya fue concedido en una visita previa,
    // relee el GPS sin prompt y reescribe la cookie -> dispara location-ready ->
    // repinta con la zona ACTUAL. No molesta al usuario.
    if (window.iShopCoveragePE && window.iShopCoveragePE.refrescarUbicacionSiPermitido) {
      window.iShopCoveragePE.refrescarUbicacionSiPermitido();
    }
    return true;
  }
  function start() {
    if (init()) return;
    var tries = 0;
    var iv = setInterval(function () { tries++; if (init() || tries > 40) clearInterval(iv); }, 250);
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('.js-make-my-store-btn, .js-store-locator-select-btn')) {
        setTimeout(function () { var s = document.querySelector(SLIDE_SEL); if (s) aplicar(s); }, 600);
      }
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();